import React from "react";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../assets/sbw 1.png";
import VersionBetaLogo from "../assets/VersionBetaLogo.svg";
import * as Yup from "yup";
import FormField from "../utility/FormField";
import background from "../assets/background.png";
import { loginData } from "../store/reducers/login";
import Button from "./Button";
import { toast } from "react-toastify";
import { isTokenExpired, getValidSession } from "../utility/TokenExpCheck";

const Login = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = React.useState(false);

  React.useEffect(() => {
    const session = getValidSession();
    if (session?.role === "client_admin") {
      history("/dashboard");
    } else if (session?.role) {
      history("/admin");
    }
  }, []);

  const initialValues = {
    sm_email: localStorage.getItem("sm_email") || "",
    sm_password: localStorage.getItem("sm_password") || "",
  };
  const validationSchema = Yup.object().shape({
    sm_email: Yup.string()
      .email("Invalid email format")
      .required("Email ID is required"),
    sm_password: Yup.string().required("Password is required"),
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleRememberMe = (values) => {
    if (values.staySignedIn === true) {
      localStorage.setItem("sm_email", values.sm_email);
      localStorage.setItem("sm_password", values.sm_password);
    } else {
      localStorage.removeItem("sm_email");
      localStorage.removeItem("sm_password");
    }
  };

  return (
    <>
      <div
        className="min-h-screen"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="grid grid-cols-12">
          <div className="col-span-4 md:col-span-6 lg:col-span-7 xl:col-span-8 2xl:col-span-8"></div>

          <div className="min-h-screen col-span-8 md:col-span-6 lg:col-span-5 xl:col-span-4 2xl:col-span-4 bg-[#0d223d]/60 backdrop-blur-[80px] shadow-lg flex flex-col justify-center p-6 sm:p-8">
            <div className="w-full flex flex-col items-center space-y-4">
              <>
                <div className="relative inline-block">
                  <img
                    src={Logo}
                    className="w-full sm:max-w-[140px] lg:max-w-[262px]"
                  />

                  <img
                    src={VersionBetaLogo}
                    className="absolute"
                    style={{
                      top: "20%",
                      right: "10%",
                      width: "15%"
                    }}
                  />
                </div>
              </>
              <div className="w-full border-t border-[#b3b5bd] my-2 sm:my-3 mb-6"></div>
              <div className="w-full">
                <h6 className="text-[#F3F4F8] text-sm sm:text-[14px] lg:text-[16px] font-normal font-['Poppins'] leading-snug mb-6">
                  Log in and explore the features on website.
                </h6>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      const payload = {
                        sm_email: values.sm_email,
                        sm_password: values.sm_password,
                      };
                      const response = await dispatch(loginData(payload));
                      if (response?.payload?.status === "success") {
                        const { accessToken, refreshToken, role } =
                          response.payload.data;

                        localStorage.setItem("token", accessToken);
                        localStorage.setItem("role", role);
                        localStorage.setItem("refreshToken", refreshToken);

                        handleRememberMe(values);

                        if (["client_admin", "client_user"].includes(role)) {
                          history("/dashboard");
                        } else if (
                          ["super_admin", "site_admin", "operator"].includes(
                            role,
                          )
                        ) {
                          history("/admin");
                        } else {
                          toast.error("Unauthorized role");
                        }
                      }
                    } catch (error) {
                      toast.error("Unexpected error occurred");
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({ isSubmitting, isValid, values }) => {
                    const isFormFilled =
                      values.sm_email.trim() !== "" &&
                      values.sm_password.trim() !== "";
                    return (
                      <Form>
                        <div className="space-y-4 sm:space-y-5">
                          <FormField
                            label="Email ID"
                            name="sm_email"
                            type="text"
                          />
                          <FormField
                            label="Password"
                            name="sm_password"
                            as="password"
                            showPassword={showPassword}
                            togglePasswordVisibility={togglePasswordVisibility}
                          />
                          <FormField
                            label="Stay signed in"
                            name="staySignedIn"
                            as="checkbox"
                          />
                        </div>
                        <div className="mt-2 md:mt-6 lg:mt-8 xl:mt-10 2xl:mt-12">
                          <Button
                            type="submit"
                            disabled={isSubmitting || !isValid || !isFormFilled}
                            primary={isValid && isFormFilled}
                          >
                            Continue
                          </Button>
                        </div>
                        <button
                          type="button"
                          className="mt-3 w-full text-[#F3F4F8] text-xs sm:text-sm font-normal p-1 rounded-lg transition duration-300"
                          onClick={() => history("/forgotpassword")}
                        >
                          Forgot password?
                        </button>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
